/* eslint-disable react/prop-types */
import React from "react";
import { Box } from "@mui/material";
import LeftNavBar from "./LeftNavBar";
import TopNavBar from "./TopNavBar";

const NavBarSection = () => {
  return (
    <Box
      component="nav"
      id="site-frontend-nav-bar-section"
      style={{
        position: "relative",
        backgroundColor: "transparent",
        padding: 0,
        margin: 0,
        width: "100%",
      }}
    >
      <TopNavBar />
      <LeftNavBar />
    </Box>
  );
};

export default NavBarSection;
